"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelectionBoxSelectedWrapper = exports.StyledSelectionBoxSelected = exports.StyledSelectionBox = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3;

var StyledSelectionBoxSelectedWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SelectionBoxstyles__StyledSelectionBoxSelectedWrapper",
  componentId: "sc-1p4ly3h-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    absolute top-0 bottom-0 right-0 z-1\n    ", "\n  "])), function (_ref) {
  var _selectionBox$checked;

  var selectionBox = _ref.theme.selectionBox;
  return selectionBox === null || selectionBox === void 0 ? void 0 : (_selectionBox$checked = selectionBox.checked) === null || _selectionBox$checked === void 0 ? void 0 : _selectionBox$checked.container;
}));

exports.StyledSelectionBoxSelectedWrapper = StyledSelectionBoxSelectedWrapper;

var StyledSelectionBox = _styledComponents["default"].div.withConfig({
  displayName: "SelectionBoxstyles__StyledSelectionBox",
  componentId: "sc-1p4ly3h-1"
})(["", " ", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    flex-auto ba justify-between flex flex-column relative h-100 pointer mw-100\n    ", "\n    ", "\n  "])), function (_ref2) {
  var selected = _ref2.selected,
      selectionBox = _ref2.theme.selectionBox;
  return "\n      ".concat(selectionBox === null || selectionBox === void 0 ? void 0 : selectionBox.borderRadius, "\n      ").concat(selectionBox === null || selectionBox === void 0 ? void 0 : selectionBox.borderWidth, "\n      ").concat(selected ? "b--".concat(selectionBox === null || selectionBox === void 0 ? void 0 : selectionBox.borderColorSelected) : "b--".concat(selectionBox === null || selectionBox === void 0 ? void 0 : selectionBox.borderColor), "\n      ").concat(selected && (selectionBox === null || selectionBox === void 0 ? void 0 : selectionBox.borderWidthSelected), "\n    ");
}, function (_ref3) {
  var enabled = _ref3.enabled;
  return !enabled && 'b--transparent';
}), function (_ref4) {
  var _selectionBox$overrid, _selectionBox$overrid2, _selectionBox$overrid3;

  var enabled = _ref4.enabled,
      selectionBox = _ref4.theme.selectionBox;
  return "\n    ".concat(selectionBox === null || selectionBox === void 0 ? void 0 : (_selectionBox$overrid = selectionBox.overrides) === null || _selectionBox$overrid === void 0 ? void 0 : _selectionBox$overrid.base, "\n    ").concat(enabled ? selectionBox === null || selectionBox === void 0 ? void 0 : (_selectionBox$overrid2 = selectionBox.overrides) === null || _selectionBox$overrid2 === void 0 ? void 0 : _selectionBox$overrid2.enabled : selectionBox === null || selectionBox === void 0 ? void 0 : (_selectionBox$overrid3 = selectionBox.overrides) === null || _selectionBox$overrid3 === void 0 ? void 0 : _selectionBox$overrid3.disabled, "\n  ");
});

exports.StyledSelectionBox = StyledSelectionBox;

var StyledSelectionBoxSelected = _styledComponents["default"].div.withConfig({
  displayName: "SelectionBoxstyles__StyledSelectionBoxSelected",
  componentId: "sc-1p4ly3h-2"
})(["", " ", ""], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref5) {
  var _selectionBox$checked2;

  var selectionBox = _ref5.theme.selectionBox;
  return "\n      ".concat(selectionBox === null || selectionBox === void 0 ? void 0 : (_selectionBox$checked2 = selectionBox.checked) === null || _selectionBox$checked2 === void 0 ? void 0 : _selectionBox$checked2.base, "\n      bg-").concat(selectionBox === null || selectionBox === void 0 ? void 0 : selectionBox.borderColorSelected, "\n    ");
}), function (_ref6) {
  var _selectionBox$checked3;

  var selectionBox = _ref6.theme.selectionBox;
  return selectionBox === null || selectionBox === void 0 ? void 0 : (_selectionBox$checked3 = selectionBox.checked) === null || _selectionBox$checked3 === void 0 ? void 0 : _selectionBox$checked3.overrides;
});

exports.StyledSelectionBoxSelected = StyledSelectionBoxSelected;